/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
import IframeView from "../../../managers/views/iframe";
import { EVENTS } from "../../utils/constants";
import {defer, isNumber, createBlobUrl, bounds} from "../../../utils/core";
import ExContents from "../../contents";
import ExEpubCFI from "../../epubcfi";
import { Pane, Highlight, Underline } from "marks-pane";

class ExIframeView extends IframeView{
	constructor(section, options, book, rendition){
		super(section, options);
		this.book = book;
		this.rendition = rendition;

		//置換ExEpubCFI
		this.epubcfi = new ExEpubCFI();
	}

	container(axis) {
		var element = document.createElement("div");

		element.classList.add("epub-view");

		element.style.height = "0px";
		element.style.width = "0px";
		
		element.style.overflow = "hidden";
		element.style.position = "relative";
		element.style.display = "block";

		if(axis && axis == "horizontal"){
			element.style.flex = "none";
		} else {
			element.style.flex = "initial";
		}

		return element;
	}

	create() {

		if(this.iframe) {
			return this.iframe;
		}

		if(!this.element) {
			this.element = this.createContainer();
		}

		this.iframe = document.createElement("iframe");
		this.iframe.id = this.id;
		this.iframe.scrolling = "no"; // Might need to be removed: breaks ios width calculations
		this.iframe.style.overflow = "hidden";
		this.iframe.seamless = "seamless";
		// Back up if seamless isn't supported
		this.iframe.style.border = "none";

		// sandbox
		// web mweb 的 iframe 不用再加入 sandbox 設定
		if(!this.book.settings.encryptType){
			this.iframe.sandbox = "allow-same-origin";
			if (this.settings.allowScriptedContent) {
				this.iframe.sandbox += " allow-scripts";
			}
		}

		this.iframe.setAttribute("enable-annotation", "true");

		this.resizing = true;

		// this.iframe.style.display = "none";
		this.element.style.visibility = "hidden";
		this.iframe.style.visibility = "hidden";

		this.iframe.style.width = "0";
		this.iframe.style.height = "0";
		this._width = 0;
		this._height = 0;

		this.element.setAttribute("ref", this.index);

		this.added = true;

		this.elementBounds = bounds(this.element);

		// if(width || height){
		//   this.resize(width, height);
		// } else if(this.width && this.height){
		//   this.resize(this.width, this.height);
		// } else {
		//   this.iframeBounds = bounds(this.iframe);
		// }

		//補白頁
		/*if (this.layout.name === "pre-paginated" && this.section){
			if(this.rendition._layout._spread && this.section.properties.includes("page-spread-center-left")){
				this.createEmptyPage("right");
			}else if(this.rendition._layout._spread && this.section.properties.includes("page-spread-center-right")){
				this.createEmptyPage("left");
			}
		}*/

		//補loading頁面
		if(this.rendition.manager.name === "continuous" && this.section && this.rendition.manager._constentSize){
			this.element.style.visibility = "visible";
			if(this.rendition._layout._spread){
				if(this.section.properties.includes("page-spread-left") || this.section.properties.includes("rendition:page-spread-left")){
					this.createLoadingPage("right");
				}else if(this.section.properties.includes("page-spread-right") || this.section.properties.includes("rendition:page-spread-right")){
					this.createLoadingPage("left");
				}else if(this.section.properties.includes("page-spread-center-left")){
					this.createLoadingPage("center-right");
				}else if(this.section.properties.includes("page-spread-center-right")){
					this.createLoadingPage("center-left");
				}
			}else{
				this.createLoadingPage("center");
			}
		}

		if(("srcdoc" in this.iframe)) {
			this.supportsSrcdoc = true;
		} else {
			this.supportsSrcdoc = false;
		}

		if (!this.settings.method) {
			this.settings.method = this.supportsSrcdoc ? "srcdoc" : "write";
		}

		return this.iframe;
	}

	createLoadingPage(align){
		if(this.loadingPage) {
			return this.loadingPage;
		}
		this.loadingPage = document.createElement("div");
		this.loadingPage.id = "epubjs-view-loading-page";
		this.loadingPage.style.overflow = "hidden";
		this.loadingPage.style.border = "none";
		this.loadingPage.style.width = this.rendition.manager._constentSize.width+"px";
		this.loadingPage.style.height = this.rendition.manager._constentSize.height+"px";
		this.loadingPage.style.zIndex = 2;
		this.loadingPage.style.visibility = "visible";
		this.loadingPage.style.position = 'absolute';
		this.loadingPage.style.backgroundImage = 'url(\'data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg width="118px" height="105px" viewBox="0 0 118 105" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>573794C8-EC35-4E06-AA82-BC8C1583E5C7</title><g id="202308fixlayout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="A.fixlayout" transform="translate(-118.000000, -263.000000)"><g id="Group-3" transform="translate(0.000000, 263.000000)"><g id="View/Util/img_bg_viewer_fix_loading" transform="translate(118.000000, 0.000000)"><g id="Group-9" transform="translate(19.000000, 17.000000)" fill="%23E5E5E5"><path d="M8.52242697,28.0833148 C7.85642258,25.1277997 7.19050479,22.1724583 6.5245437,19.2170734 C6.36243731,18.4774455 6.27856977,17.6883093 6.27233491,16.9000851 C5.99319499,16.285661 5.66815956,15.6959477 5.30645103,15.155569 C3.82536846,12.9634805 2.34385291,10.7715223 0.86281364,8.57934699 C0.278641803,7.66279205 -0.181179195,7.87163889 0.0703801271,8.93862958 C0.587960185,11.4251187 1.10614641,13.911521 1.62420274,16.3978798 C1.92823881,17.8228503 2.5243175,19.2780034 3.30202981,20.4941704 C5.00665813,23.1325284 6.71288846,25.7698875 8.41812294,28.4077678 C8.64980864,28.7872446 8.85616522,28.9787201 9,29 C8.95670235,28.9544437 8.91604586,28.9054131 8.87707798,28.8546888 C8.73787605,28.7769521 8.60365335,28.5202472 8.52242697,28.0833148" id="Fill-1"></path><path d="M7.09135422,13.4563976 C8.0763341,11.9289574 9.05819574,10.4722124 10,9.07909782 C9.57913362,6.35234035 9.2385739,4.55168773 8.81123118,1.85927183 C8.71408603,0.727341058 8.24001769,0.709588964 8.05124427,1.83065385 C7.21886623,5.89668835 7.03249145,9.43168035 6.20044922,13.4977596 C6.04113118,14.2993762 5.97771098,15.1525946 6.00687851,16 C6.05849737,15.6576126 6.14465673,15.3178188 6.26185456,14.9914843 C6.44894892,14.4240433 6.78667824,13.928818 7.09135422,13.4563976" id="Fill-3"></path><path d="M31.9440793,18.0025404 C32.206158,19.2325133 31.5230487,20.6233157 30.3974,21.1497583 C24.1438804,24.03943 17.89045,26.9291894 11.6371088,29.8191679 C10.559699,30.3248385 9.36474871,29.7278851 9.10128666,28.5526906 C8.42174738,25.6002209 7.74225271,22.6477512 7.06271342,19.6952815 C6.78684582,18.4660973 7.44550092,17.0581164 8.55905644,16.500472 C14.8290871,13.400714 21.0988946,10.3010437 27.3679882,7.19953289 C28.4277268,6.6667798 29.6056306,7.24396915 29.8536972,8.41855015 C30.5503722,11.6132282 31.2474489,14.8078623 31.9440793,18.0025404" id="Fill-5"></path><path d="M8.25443109,14.7422775 C12.7529151,12.4470233 17.3820011,10.0867969 22,7.8051916 C21.4907155,5.54343534 20.9816119,3.28159295 20.4722821,1.01987974 C20.2490006,-0.11539015 19.2287572,-0.353621587 18.5114869,0.562706166 C14.529528,5.37504149 11.7088682,9.87172984 7.72690933,14.6840652 C7.41990859,15.0622732 7.17476958,15.5147536 7,16 C7.27559471,15.4626122 7.71143258,15.0057831 8.25443109,14.7422775" id="Fill-7"></path></g><g id="Group-9" transform="translate(79.000000, 69.000000)" fill="%23E5E5E5"><path d="M8.52242697,28.0833148 C7.85642258,25.1277997 7.19050479,22.1724583 6.5245437,19.2170734 C6.36243731,18.4774455 6.27856977,17.6883093 6.27233491,16.9000851 C5.99319499,16.285661 5.66815956,15.6959477 5.30645103,15.155569 C3.82536846,12.9634805 2.34385291,10.7715223 0.86281364,8.57934699 C0.278641803,7.66279205 -0.181179195,7.87163889 0.0703801271,8.93862958 C0.587960185,11.4251187 1.10614641,13.911521 1.62420274,16.3978798 C1.92823881,17.8228503 2.5243175,19.2780034 3.30202981,20.4941704 C5.00665813,23.1325284 6.71288846,25.7698875 8.41812294,28.4077678 C8.64980864,28.7872446 8.85616522,28.9787201 9,29 C8.95670235,28.9544437 8.91604586,28.9054131 8.87707798,28.8546888 C8.73787605,28.7769521 8.60365335,28.5202472 8.52242697,28.0833148" id="Fill-1"></path><path d="M8.09135422,13.4563976 C9.0763341,11.9289574 10.0581957,10.4722124 11,9.07909782 C10.5791336,6.35234035 10.2385739,4.55168773 9.81123118,1.85927183 C9.71408603,0.727341058 9.24001769,0.709588964 9.05124427,1.83065385 C8.21886623,5.89668835 8.03249145,9.43168035 7.20044922,13.4977596 C7.04113118,14.2993762 6.97771098,15.1525946 7.00687851,16 C7.05849737,15.6576126 7.14465673,15.3178188 7.26185456,14.9914843 C7.44894892,14.4240433 7.78667824,13.928818 8.09135422,13.4563976" id="Fill-3"></path><path d="M32.9440793,18.0025404 C33.206158,19.2325133 32.5230487,20.6233157 31.3974,21.1497583 C25.1438804,24.03943 18.89045,26.9291894 12.6371088,29.8191679 C11.559699,30.3248385 10.3647487,29.7278851 10.1012867,28.5526906 C9.42174738,25.6002209 8.74225271,22.6477512 8.06271342,19.6952815 C7.78684582,18.4660973 8.44550092,17.0581164 9.55905644,16.500472 C15.8290871,13.400714 22.0988946,10.3010437 28.3679882,7.19953289 C29.4277268,6.6667798 30.6056306,7.24396915 30.8536972,8.41855015 C31.5503722,11.6132282 32.2474489,14.8078623 32.9440793,18.0025404" id="Fill-5"></path><path d="M9.25443109,14.7422775 C13.7529151,12.4470233 18.3820011,10.0867969 23,7.8051916 C22.4907155,5.54343534 21.9816119,3.28159295 21.4722821,1.01987974 C21.2490006,-0.11539015 20.2287572,-0.353621587 19.5114869,0.562706166 C15.529528,5.37504149 12.7088682,9.87172984 8.72690933,14.6840652 C8.41990859,15.0622732 8.17476958,15.5147536 8,16 C8.27559471,15.4626122 8.71143258,15.0057831 9.25443109,14.7422775" id="Fill-7"></path></g><g id="loading…" transform="translate(33.679000, 85.904000) rotate(-360.000000) translate(-33.679000, -85.904000) translate(8.538000, 80.264000)" fill="%23D8DAD8" fill-rule="nonzero"><polygon id="Path" points="0.026 -5.68434189e-14 0.026 8.736 0.974 8.736 0.974 -5.68434189e-14"></polygon><path d="M5.426,2.364 C4.49,2.364 3.758,2.676 3.206,3.324 C2.678,3.936 2.414,4.704 2.414,5.64 C2.414,6.564 2.678,7.332 3.206,7.932 C3.758,8.58 4.49,8.904 5.426,8.904 C6.35,8.904 7.094,8.58 7.658,7.932 C8.174,7.332 8.438,6.564 8.438,5.64 C8.438,4.704 8.174,3.936 7.646,3.324 C7.094,2.676 6.35,2.364 5.426,2.364 Z M5.426,3.168 C6.074,3.168 6.59,3.42 6.974,3.924 C7.298,4.38 7.466,4.944 7.466,5.64 C7.466,6.312 7.298,6.888 6.974,7.344 C6.59,7.848 6.074,8.1 5.426,8.1 C4.766,8.1 4.25,7.848 3.89,7.344 C3.554,6.888 3.398,6.324 3.398,5.64 C3.398,4.944 3.554,4.38 3.89,3.924 C4.25,3.42 4.766,3.168 5.426,3.168 Z" id="Shape"></path><path d="M12.386,2.364 C11.642,2.364 11.054,2.508 10.598,2.796 C10.094,3.108 9.77,3.6 9.638,4.248 L10.586,4.32 C10.682,3.924 10.886,3.624 11.21,3.432 C11.498,3.24 11.87,3.156 12.326,3.156 C13.406,3.156 13.946,3.672 13.946,4.716 L13.946,5.04 L12.458,5.064 C11.522,5.076 10.802,5.256 10.298,5.592 C9.722,5.952 9.446,6.48 9.446,7.188 C9.446,7.692 9.638,8.112 10.022,8.436 C10.394,8.748 10.886,8.904 11.51,8.904 C12.086,8.904 12.602,8.772 13.058,8.52 C13.442,8.304 13.766,8.028 14.006,7.692 L14.006,8.736 L14.906,8.736 L14.906,4.752 C14.906,4.032 14.714,3.468 14.354,3.06 C13.922,2.592 13.274,2.364 12.386,2.364 Z M13.946,5.76 L13.946,6.288 C13.946,6.768 13.718,7.2 13.274,7.572 C12.818,7.956 12.302,8.148 11.714,8.148 C11.33,8.148 11.018,8.052 10.778,7.872 C10.538,7.68 10.43,7.452 10.43,7.164 C10.43,6.264 11.126,5.808 12.518,5.784 L13.946,5.76 Z" id="Shape"></path><path d="M20.978,-5.68434189e-14 L20.978,3.672 C20.498,2.796 19.814,2.364 18.926,2.364 C18.038,2.364 17.354,2.688 16.85,3.36 C16.382,3.96 16.154,4.704 16.154,5.616 C16.154,6.552 16.382,7.32 16.85,7.92 C17.354,8.568 18.062,8.904 18.974,8.904 C19.91,8.904 20.606,8.508 21.038,7.716 L21.038,8.736 L21.938,8.736 L21.938,-5.68434189e-14 L20.978,-5.68434189e-14 Z M19.13,3.156 C19.682,3.156 20.138,3.372 20.486,3.828 C20.822,4.272 21.002,4.86 21.002,5.58 L21.002,5.7 C21.002,6.396 20.846,6.96 20.546,7.392 C20.198,7.872 19.718,8.112 19.094,8.112 C18.422,8.112 17.918,7.86 17.582,7.38 C17.282,6.948 17.138,6.36 17.138,5.616 C17.138,4.872 17.282,4.296 17.594,3.876 C17.93,3.396 18.446,3.156 19.13,3.156 Z" id="Shape"></path><path d="M24.218,0.192 C24.014,0.192 23.846,0.252 23.702,0.396 C23.558,0.516 23.498,0.684 23.498,0.9 C23.498,1.104 23.558,1.272 23.702,1.416 C23.846,1.548 24.014,1.62 24.218,1.62 C24.422,1.62 24.59,1.548 24.734,1.416 C24.878,1.272 24.95,1.104 24.95,0.9 C24.95,0.684 24.878,0.516 24.734,0.396 C24.59,0.252 24.422,0.192 24.218,0.192 Z M23.738,2.532 L23.738,8.736 L24.698,8.736 L24.698,2.532 L23.738,2.532 Z" id="Shape"></path><path d="M29.402,2.364 C28.994,2.364 28.622,2.46 28.286,2.652 C27.95,2.832 27.674,3.096 27.458,3.444 L27.458,2.532 L26.498,2.532 L26.498,8.736 L27.458,8.736 L27.458,4.992 C27.494,4.428 27.674,3.984 28.01,3.648 C28.322,3.336 28.694,3.18 29.126,3.18 C30.206,3.18 30.758,3.78 30.758,4.992 L30.758,8.736 L31.718,8.736 L31.718,4.92 C31.718,3.216 30.938,2.364 29.402,2.364 Z" id="Path"></path><path d="M35.762,2.364 C34.898,2.364 34.214,2.664 33.71,3.276 C33.206,3.852 32.966,4.584 32.966,5.496 C32.966,6.396 33.206,7.128 33.71,7.704 C34.214,8.292 34.898,8.592 35.762,8.592 C36.698,8.592 37.394,8.172 37.85,7.344 L37.85,8.436 C37.85,9.804 37.226,10.5 35.978,10.5 C35.414,10.5 34.994,10.392 34.718,10.188 C34.442,9.996 34.262,9.684 34.19,9.264 L33.23,9.264 C33.338,9.936 33.614,10.44 34.058,10.776 C34.49,11.112 35.138,11.28 35.978,11.28 C37.862,11.28 38.81,10.284 38.81,8.304 L38.81,2.532 L37.85,2.532 L37.85,3.6 C37.394,2.772 36.698,2.364 35.762,2.364 Z M35.906,3.156 C36.518,3.156 36.998,3.372 37.358,3.828 C37.694,4.236 37.862,4.8 37.862,5.496 C37.862,6.168 37.694,6.72 37.358,7.14 C36.998,7.572 36.518,7.788 35.894,7.788 C35.222,7.788 34.73,7.548 34.394,7.092 C34.094,6.684 33.95,6.144 33.95,5.496 C33.95,4.8 34.118,4.236 34.454,3.828 C34.802,3.372 35.282,3.156 35.906,3.156 Z" id="Shape"></path><path d="M41.546,7.308 C41.342,7.308 41.174,7.368 41.042,7.512 C40.898,7.644 40.826,7.812 40.826,8.016 C40.826,8.22 40.898,8.388 41.042,8.532 C41.174,8.664 41.342,8.736 41.546,8.736 C41.75,8.736 41.93,8.664 42.074,8.532 C42.206,8.4 42.278,8.232 42.278,8.016 C42.278,7.812 42.206,7.644 42.074,7.512 C41.93,7.368 41.762,7.308 41.546,7.308 Z M45.554,7.308 C45.35,7.308 45.182,7.368 45.038,7.512 C44.894,7.644 44.834,7.812 44.834,8.016 C44.834,8.22 44.894,8.388 45.038,8.532 C45.182,8.664 45.35,8.736 45.554,8.736 C45.758,8.736 45.938,8.664 46.082,8.532 C46.214,8.4 46.286,8.232 46.286,8.016 C46.286,7.812 46.214,7.644 46.082,7.512 C45.938,7.368 45.758,7.308 45.554,7.308 Z M49.55,7.308 C49.346,7.308 49.178,7.368 49.034,7.512 C48.89,7.644 48.83,7.812 48.83,8.016 C48.83,8.22 48.89,8.388 49.034,8.532 C49.178,8.664 49.346,8.736 49.55,8.736 C49.754,8.736 49.922,8.664 50.066,8.532 C50.21,8.4 50.282,8.232 50.282,8.016 C50.282,7.812 50.21,7.644 50.066,7.512 C49.922,7.368 49.754,7.308 49.55,7.308 Z" id="Shape"></path></g><g id="loading…" transform="translate(90.319000, 33.904000) rotate(-360.000000) translate(-90.319000, -33.904000) translate(65.178000, 28.264000)" fill="%23D8DAD8" fill-rule="nonzero"><polygon id="Path" points="0.026 0 0.026 8.736 0.974 8.736 0.974 0"></polygon><path d="M5.426,2.364 C4.49,2.364 3.758,2.676 3.206,3.324 C2.678,3.936 2.414,4.704 2.414,5.64 C2.414,6.564 2.678,7.332 3.206,7.932 C3.758,8.58 4.49,8.904 5.426,8.904 C6.35,8.904 7.094,8.58 7.658,7.932 C8.174,7.332 8.438,6.564 8.438,5.64 C8.438,4.704 8.174,3.936 7.646,3.324 C7.094,2.676 6.35,2.364 5.426,2.364 Z M5.426,3.168 C6.074,3.168 6.59,3.42 6.974,3.924 C7.298,4.38 7.466,4.944 7.466,5.64 C7.466,6.312 7.298,6.888 6.974,7.344 C6.59,7.848 6.074,8.1 5.426,8.1 C4.766,8.1 4.25,7.848 3.89,7.344 C3.554,6.888 3.398,6.324 3.398,5.64 C3.398,4.944 3.554,4.38 3.89,3.924 C4.25,3.42 4.766,3.168 5.426,3.168 Z" id="Shape"></path><path d="M12.386,2.364 C11.642,2.364 11.054,2.508 10.598,2.796 C10.094,3.108 9.77,3.6 9.638,4.248 L10.586,4.32 C10.682,3.924 10.886,3.624 11.21,3.432 C11.498,3.24 11.87,3.156 12.326,3.156 C13.406,3.156 13.946,3.672 13.946,4.716 L13.946,5.04 L12.458,5.064 C11.522,5.076 10.802,5.256 10.298,5.592 C9.722,5.952 9.446,6.48 9.446,7.188 C9.446,7.692 9.638,8.112 10.022,8.436 C10.394,8.748 10.886,8.904 11.51,8.904 C12.086,8.904 12.602,8.772 13.058,8.52 C13.442,8.304 13.766,8.028 14.006,7.692 L14.006,8.736 L14.906,8.736 L14.906,4.752 C14.906,4.032 14.714,3.468 14.354,3.06 C13.922,2.592 13.274,2.364 12.386,2.364 Z M13.946,5.76 L13.946,6.288 C13.946,6.768 13.718,7.2 13.274,7.572 C12.818,7.956 12.302,8.148 11.714,8.148 C11.33,8.148 11.018,8.052 10.778,7.872 C10.538,7.68 10.43,7.452 10.43,7.164 C10.43,6.264 11.126,5.808 12.518,5.784 L13.946,5.76 Z" id="Shape"></path><path d="M20.978,-1.13686838e-13 L20.978,3.672 C20.498,2.796 19.814,2.364 18.926,2.364 C18.038,2.364 17.354,2.688 16.85,3.36 C16.382,3.96 16.154,4.704 16.154,5.616 C16.154,6.552 16.382,7.32 16.85,7.92 C17.354,8.568 18.062,8.904 18.974,8.904 C19.91,8.904 20.606,8.508 21.038,7.716 L21.038,8.736 L21.938,8.736 L21.938,-1.13686838e-13 L20.978,-1.13686838e-13 Z M19.13,3.156 C19.682,3.156 20.138,3.372 20.486,3.828 C20.822,4.272 21.002,4.86 21.002,5.58 L21.002,5.7 C21.002,6.396 20.846,6.96 20.546,7.392 C20.198,7.872 19.718,8.112 19.094,8.112 C18.422,8.112 17.918,7.86 17.582,7.38 C17.282,6.948 17.138,6.36 17.138,5.616 C17.138,4.872 17.282,4.296 17.594,3.876 C17.93,3.396 18.446,3.156 19.13,3.156 Z" id="Shape"></path><path d="M24.218,0.192 C24.014,0.192 23.846,0.252 23.702,0.396 C23.558,0.516 23.498,0.684 23.498,0.9 C23.498,1.104 23.558,1.272 23.702,1.416 C23.846,1.548 24.014,1.62 24.218,1.62 C24.422,1.62 24.59,1.548 24.734,1.416 C24.878,1.272 24.95,1.104 24.95,0.9 C24.95,0.684 24.878,0.516 24.734,0.396 C24.59,0.252 24.422,0.192 24.218,0.192 Z M23.738,2.532 L23.738,8.736 L24.698,8.736 L24.698,2.532 L23.738,2.532 Z" id="Shape"></path><path d="M29.402,2.364 C28.994,2.364 28.622,2.46 28.286,2.652 C27.95,2.832 27.674,3.096 27.458,3.444 L27.458,2.532 L26.498,2.532 L26.498,8.736 L27.458,8.736 L27.458,4.992 C27.494,4.428 27.674,3.984 28.01,3.648 C28.322,3.336 28.694,3.18 29.126,3.18 C30.206,3.18 30.758,3.78 30.758,4.992 L30.758,8.736 L31.718,8.736 L31.718,4.92 C31.718,3.216 30.938,2.364 29.402,2.364 Z" id="Path"></path><path d="M35.762,2.364 C34.898,2.364 34.214,2.664 33.71,3.276 C33.206,3.852 32.966,4.584 32.966,5.496 C32.966,6.396 33.206,7.128 33.71,7.704 C34.214,8.292 34.898,8.592 35.762,8.592 C36.698,8.592 37.394,8.172 37.85,7.344 L37.85,8.436 C37.85,9.804 37.226,10.5 35.978,10.5 C35.414,10.5 34.994,10.392 34.718,10.188 C34.442,9.996 34.262,9.684 34.19,9.264 L33.23,9.264 C33.338,9.936 33.614,10.44 34.058,10.776 C34.49,11.112 35.138,11.28 35.978,11.28 C37.862,11.28 38.81,10.284 38.81,8.304 L38.81,2.532 L37.85,2.532 L37.85,3.6 C37.394,2.772 36.698,2.364 35.762,2.364 Z M35.906,3.156 C36.518,3.156 36.998,3.372 37.358,3.828 C37.694,4.236 37.862,4.8 37.862,5.496 C37.862,6.168 37.694,6.72 37.358,7.14 C36.998,7.572 36.518,7.788 35.894,7.788 C35.222,7.788 34.73,7.548 34.394,7.092 C34.094,6.684 33.95,6.144 33.95,5.496 C33.95,4.8 34.118,4.236 34.454,3.828 C34.802,3.372 35.282,3.156 35.906,3.156 Z" id="Shape"></path><path d="M41.546,7.308 C41.342,7.308 41.174,7.368 41.042,7.512 C40.898,7.644 40.826,7.812 40.826,8.016 C40.826,8.22 40.898,8.388 41.042,8.532 C41.174,8.664 41.342,8.736 41.546,8.736 C41.75,8.736 41.93,8.664 42.074,8.532 C42.206,8.4 42.278,8.232 42.278,8.016 C42.278,7.812 42.206,7.644 42.074,7.512 C41.93,7.368 41.762,7.308 41.546,7.308 Z M45.554,7.308 C45.35,7.308 45.182,7.368 45.038,7.512 C44.894,7.644 44.834,7.812 44.834,8.016 C44.834,8.22 44.894,8.388 45.038,8.532 C45.182,8.664 45.35,8.736 45.554,8.736 C45.758,8.736 45.938,8.664 46.082,8.532 C46.214,8.4 46.286,8.232 46.286,8.016 C46.286,7.812 46.214,7.644 46.082,7.512 C45.938,7.368 45.758,7.308 45.554,7.308 Z M49.55,7.308 C49.346,7.308 49.178,7.368 49.034,7.512 C48.89,7.644 48.83,7.812 48.83,8.016 C48.83,8.22 48.89,8.388 49.034,8.532 C49.178,8.664 49.346,8.736 49.55,8.736 C49.754,8.736 49.922,8.664 50.066,8.532 C50.21,8.4 50.282,8.232 50.282,8.016 C50.282,7.812 50.21,7.644 50.066,7.512 C49.922,7.368 49.754,7.308 49.55,7.308 Z" id="Shape"></path></g></g></g></g></g></svg>\')';
		this.loadingPage.style.pointerEvents = "none";
		if( !((this.rendition.settings.isWebtoon && !this.rendition._layout._spread && this.rendition.manager.name === "continuous") || (this.rendition.settings.isDomTriggerByTouch && !this.rendition.settings.isWebtoon && this.rendition._layout._spread && this.rendition.manager.name === "continuous")) ){
			this.loadingPage.style.top = ((this.layout.height - this.rendition.manager._constentSize.height) / 2) + "px";
		}
		switch(align){
			case "right": this.loadingPage.style.right = 0;
						  break;
			case "left": this.loadingPage.style.left = 0;
						 break;
			case "center": this.loadingPage.style.left = ((this.layout.columnWidth - this.rendition.manager._constentSize.width) / 2) + "px";
						   break;
			case "center-right": this.loadingPage.style.left = this.layout.columnWidth+"px";
								 break;
			case "center-left": this.loadingPage.style.right = this.layout.columnWidth+"px";
					            break;
		}
		if(this.element){
			this.element.appendChild(this.loadingPage);
		}
	}

	createEmptyPage(align){
		if(this.emptyPage) {
			return this.emptyPage;
		}
		this.emptyPage = document.createElement("div");
		this.emptyPage.id = "epubjs-view-empty-page";
		this.emptyPage.style.overflow = "hidden";
		this.emptyPage.style.border = "none";
		this.emptyPage.style.visibility = "hidden";
		this.emptyPage.style.width = "0";
		this.emptyPage.style.height = "0";
		this.emptyPage.style.position = 'absolute';
		this.emptyPage.style.backgroundColor = "white";
		if(align === "right"){
			this.emptyPage.style.left = this.layout.columnWidth+"px";
		}else{
			this.emptyPage.style.right = this.layout.columnWidth+"px";
		}
		this.emptyPage.style.pointerEvents = "none";
	}
	setEmptyPage(size){
		if(this.emptyPage && this.emptyPage.style.visibility === "hidden") {
			this.emptyPage.style.width = size.width+"px";
			this.emptyPage.style.height = size.height+"px";
			this.emptyPage.style.top = "0";
			this.emptyPage.style.visibility = "visible";
		}
	}

	load(contents) {

		var loading = new defer();
		var loaded = loading.promise;
		if(!this.iframe) {
			loading.reject(new Error("No Iframe Available"));
			return loaded;
		}
		
		//使用 blobUrl 和 srcdoc 模式, 都會把 decode 過後的書籍內容顯示出來, 所以還是用傳統的 write 模式
		this.element.appendChild(this.iframe);

		if(this.emptyPage){
			this.element.appendChild(this.emptyPage);
		}

		this.document = this.iframe.contentDocument;

		if(!this.document) {
			//已修正 No Document Available 的處理方式, 所以發生錯誤時, 顯示流程不會被中斷
			//所已此項錯誤應該會拋出, 須處裡拋出後流程
			loading.reject(new Error(`${this.section.index} No Document Available`));
			return loaded;
		}else{
			this.iframe.onload = function(event) {
				this.onLoad(event, loading);
			}.bind(this);

			this.iframe.contentDocument.open();
			// For Cordova windows platform
			if(window.MSApp && MSApp.execUnsafeLocalFunction) {
				var outerThis = this;
				MSApp.execUnsafeLocalFunction(function () {
					outerThis.iframe.contentDocument.write(contents);
				});
			} else {
				this.iframe.contentDocument.write(contents);
			}
			this.iframe.contentDocument.close();
		}

		return loaded;
	}

	show() {

		this.element.style.visibility = "visible";

		if(this.iframe){
			this.iframe.style.visibility = "visible";

			// Remind Safari to redraw the iframe
			this.iframe.style.transform = "translateZ(0)";
			this.iframe.offsetWidth;
			this.iframe.style.transform = null;
		}

		if(this.loadingPage){
			this.loadingPage.style.display = "none";
			this.loadingPage.style.visibility = "hidden";
		}

		this.emit(EVENTS.VIEWS.SHOWN, this);
	}

	hide() {
		// this.iframe.style.display = "none";
		this.element.style.visibility = "hidden";
		this.iframe.style.visibility = "hidden";

		if(this.loadingPage){
			this.element.style.visibility = "visible";
			this.loadingPage.style.display = "block";
			this.loadingPage.style.visibility = "visible";
		}

		this.stopExpanding = true;
		this.emit(EVENTS.VIEWS.HIDDEN, this);
	}

	onLoad(event, promise) {
		//置入原本html屬性
		$("html",this.section.document).each((index, element)=>{
			$.each(element.attributes, (attrIndex, attr) => {
				if(attr.specified) {
					$("html",this.iframe.contentDocument).attr(attr.name, attr.value);
				}
			});
		});

		this.window = this.iframe.contentWindow;
		this.document = this.iframe.contentDocument;

		//同步section物件中的document, 因為原書的xhtml有不正確換行或結構時會導致iframe中的document和section中的不同
		this.section.document = this.document.cloneNode(true);
		
		this.contents = new ExContents(this.document, this.document.body, this.section.cfiBase, this.section.index, this.book.rendition);

		this.rendering = false;

		var link = this.document.querySelector("link[rel='canonical']");
		if (link) {
			link.setAttribute("href", this.section.canonical);
		} else {
			link = this.document.createElement("link");
			link.setAttribute("rel", "canonical");
			link.setAttribute("href", this.section.canonical);
			this.document.querySelector("head").appendChild(link);
		}

		//一取得內容時的觸發, 目前已取消
		this.contents.on(EVENTS.CONTENTS.EXPAND, () => {
			if(this.displayed && this.iframe) {
				this.expand();
				if (this.contents) {
					this.layout.format(this.contents);
				}
			}
		});

		this.contents.on(EVENTS.CONTENTS.RESIZE, (e) => {
			if(this.displayed && this.iframe) {
				this.expand();
				if (this.contents) {
					this.layout.format(this.contents);
				}
			}
		});

		promise.resolve(this.contents);
	}

	render(request, show) {

		// view.onLayout = this.layout.format.bind(this.layout);
		this.create();

		// Fit to size of the container, apply padding
		this.size();

		if(!this.sectionRender) {
			this.sectionRender = this.section.render(request);

			//加入GET_SECTION_RENDER事件
			this.emit(EVENTS.VIEWS.GET_SECTION_RENDER, this.section);
		}

		// Render Chain
		return this.sectionRender
			.then(function(contents){
				return this.load(contents);
			}.bind(this))
			.then(function(){
				// find and report the writingMode axis
				let writingMode = this.contents.writingMode();

				// Set the axis based on the flow and writing mode
				let axis;
				if (this.settings.flow === "scrolled") {
					axis = (writingMode.indexOf("vertical") === 0) ? "horizontal" : "vertical";
				} else {
					axis = (writingMode.indexOf("vertical") === 0) ? "vertical" : "horizontal";
				}

				if (writingMode.indexOf("vertical") === 0 && this.settings.flow === "paginated") {
					this.layout.delta = this.layout.height;
				}

				this.setAxis(axis);
				this.emit(EVENTS.VIEWS.AXIS, axis);

				this.setWritingMode(writingMode);
				this.emit(EVENTS.VIEWS.WRITING_MODE, writingMode);


				// apply the layout function to the contents
				this.layout.format(this.contents, this.section, this.axis);

				// Listen for events that require an expansion of the iframe
				this.addListeners();

				return new Promise((resolve, reject) => {
					// Expand the iframe to the full size of the content
	
					//這邊先移除, 待字型載完再發
					//this.expand();

					// 移除forceRight判讀
					// if (this.settings.forceRight) {
					// 	this.element.style.marginLeft = this.width() + "px";
					// }
					resolve();
				});

			}.bind(this), function(e){
				this.emit(EVENTS.VIEWS.LOAD_ERROR, e);
				return new Promise((resolve, reject) => {
					reject(e);
				});
			}.bind(this))
			.then(function() {
				this.emit(EVENTS.VIEWS.RENDERED, this.section);
			}.bind(this));

	}

	locationOf(target) {
		if(this.iframe){
			var parentPos = this.iframe.getBoundingClientRect();
		}

		var targetPos = null;
		if(this.contents){
			targetPos = this.contents.locationOf(target, this.settings.ignoreClass);
			targetPos = {left:targetPos.left, top:targetPos.top};
		}
		return targetPos;
	}

	emitHighlightSelect(data){
		this.emit(EVENTS.VIEWS.MARK_MOUSE_UP, this.rendition._lastEventData, data);
	}

	highlight(cfiRange, data={}, cb, className = "epubjs-hl", styles = {}) {
		if (!this.contents || this.rendition.settings.isHidden) {
			return;
		}

		const attributes = Object.assign({"fill": "yellow", "fill-opacity": "0.3", "mix-blend-mode": "multiply"}, styles);
		let range = this.contents.range(cfiRange);

		if(!range){
			return;
		}

		let mouseDownEmitter = (e) => {
			if(this.rendition._isFakeEvent){
				return true;
			}
			this.emit(EVENTS.VIEWS.MARK_MOUSE_DOWN, e, cfiRange, data);
		}

		let mouseUpEmitter = (e) => {
			if(this.rendition._isFakeEvent){
				return true;
			}
			//如果目前沒有選取範圍才觸發 MARK_CLICKED
			let selection =  this.document.defaultView.getSelection();
			let adjustRangeCFI = null;
			if(!(selection && !selection.isCollapsed && selection.type === "Range")){

				//若highlight有發生跨頁情形, 僅選取當頁的highlight範圍
				if(this.rendition.location){
					
					let selectStartCFI = this.epubcfi.getStartCFIFromRange(cfiRange);
					let selectEndCFI = this.epubcfi.getEndCFIFromRange(cfiRange);
					let locationStartCFI = this.rendition.location.start.cfi;
					let locationEndCFI = this.rendition.location.end.cfi;
					let finalStartCFI = (this.epubcfi.compare(selectStartCFI,locationStartCFI) >= 0) ? selectStartCFI : locationStartCFI;
					let finalEndCFI = (this.epubcfi.compare(locationEndCFI,selectEndCFI) >= 0) ? selectEndCFI : locationEndCFI;

					if(finalStartCFI !== selectStartCFI || finalEndCFI !== selectEndCFI){
						if(finalStartCFI !== selectStartCFI && finalStartCFI.includes(":")){
							let finalStartCFIArray = finalStartCFI.split(":");
							let textPo = parseInt(finalStartCFIArray[1], 10) + 1;
							let adjustFinalStartCFI = `${finalStartCFIArray[0]}:${textPo}`;
							if(adjustFinalStartCFI !== finalEndCFI){
								finalStartCFI = adjustFinalStartCFI;
							}
						}
						adjustRangeCFI = this.epubcfi.getRangeFromStartEndCFI(finalStartCFI, finalEndCFI);
						//let adjustRange = this.contents.range(adjustRangeCFI);
						//let adjustRect = adjustRange.getBoundingClientRect();
						//console.log(adjustRect);
						
					}
				}
				//清空選取範圍
				selection.removeAllRanges();
				//選取畫線範圍
				range = this.contents.range(cfiRange);
				if(range){
					selection.addRange(range);
					if(this.rendition.settings.isWakeAppSelectionController){
						let doc = range.startContainer.ownerDocument;
						let startRange = doc.createRange();
						startRange.setStart(range.startContainer, range.startOffset);
						startRange.setEnd(range.startContainer, range.startOffset+1);
						let pos = startRange.getBoundingClientRect();
						let globalPos = this.rendition.conventToGlobalPosition(pos);
						this.emit(EVENTS.VIEWS.WAKE_SELECTION_CONTROLLER, {viewerX:globalPos.x+pos.width/2, viewerY:globalPos.y});
					}
					this.contents.setPreSelectRange(range);
				}
				if(adjustRangeCFI){
					let clonedData = Object.assign({}, data);
					clonedData.displayCfi = adjustRangeCFI;
					this.emit(EVENTS.VIEWS.MARK_MOUSE_UP, this.rendition._lastEventData, clonedData);
				}else{
					this.emit(EVENTS.VIEWS.MARK_MOUSE_UP, this.rendition._lastEventData, data);
				}
				
				
			}
		};

		data["cfi"] = cfiRange;

		if (!this.pane) {
			this.pane = new Pane(this.iframe, this.element);
		}

		let m = new Highlight(range, className, data, attributes);
		let h = this.pane.addMark(m);

		this.highlights[cfiRange] = { "mark": h, "element": h.element, "listeners": [mouseDownEmitter, mouseUpEmitter] };

		//加入icon
		this.addHighlightIcon(this.highlights[cfiRange]);

		h.element.setAttribute("ref", className);

		//mweb不支援highlight點擊
		if(!this.book.settings.encryptType || (this.book.settings.encryptType && !this.rendition.settings.isDomTriggerByTouch)){
			h.element.addEventListener("mousedown", mouseDownEmitter);
			h.element.addEventListener("touchstart", mouseDownEmitter);
			h.element.addEventListener("mouseup", mouseUpEmitter);
			h.element.addEventListener("touchend", mouseUpEmitter);
		}
		return h;
	}

	// Resize a single axis based on content dimensions
	expand(force) {
		var width = this.lockedWidth;
		var height = this.lockedHeight;
		var columns;

		var textWidth, textHeight;
		var minTextSize;

		if(!this.iframe || this._expanding) return;

		this._expanding = true;

		let stageSize, result;
		if(this.layout.name === "pre-paginated") {
			if(this.rendition.settings.isWebtoon && !this.rendition._layout._spread && this.rendition.manager.name === "continuous"){
				//條漫單頁滾動瀏覽
				stageSize = this.rendition.manager.stage.size();
				result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
				width = result.columnWidth;
				this.contents.resizeCheck();
				height = this.contents._size.height;
			}else{
				if(this.rendition.settings.isDomTriggerByTouch){
					//app, mweb
					if(this.rendition.settings.isWebtoon){
						//條漫雙拼, 翻頁模式
						stageSize = this.rendition.manager.stage.size();
						result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
						width = result.columnWidth;
						this.contents.fit(width, this.layout.height, this.section, result.divisor);
						height = this.layout.height;
					}else{
						if(this.rendition.manager.name === "continuous"){
							if(!this.rendition._layout._spread){
								//固定版單頁, 雙拼滾動瀏覽
								stageSize = this.rendition.manager.stage.size();
								result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
								width = result.columnWidth;
								this.contents.resizeCheck();
								height = this.contents._size.height;
							}else{
								//固定版雙拼滾動瀏覽
								stageSize = this.rendition.manager.stage.size();
								result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
								width = result.columnWidth;
								this.contents.resizeCheck();
								height = this.contents._size.height;
							}
						}else{
							//固定版翻頁模式
							stageSize = this.rendition.manager.stage.size();
							result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
							width = result.columnWidth;
							this.contents.fit(width, this.layout.height, this.section, result.divisor);
							height = this.layout.height;
						}
					}
				}else{
					//web版
					stageSize = this.rendition.manager.stage.size();
					result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
					width = result.columnWidth;
					this.contents.fit(width, this.layout.height, this.section, result.divisor);
					height = this.layout.height;
				}

				/*
				//固定版自行運算寬度
				let stageSize = this.rendition.manager.stage.size();
				let result = this.layout.calculate(this.section, stageSize.width, stageSize.height, null, false);
				width = result.columnWidth;
				this.contents.fit(width, this.layout.height, this.section, result.divisor);
				height = this.layout.height;
				*/
			}
		}
		// Expand Horizontally
		else if(this.settings.axis === "horizontal") {
			// Get the width of the text
			width = this.contents.textWidth();
			minTextSize = this.rendition.themes._booksFontSize * this.rendition.themes._booksLineHeight;
			if (width % this.layout.pageWidth > minTextSize) {
				//console.log("expend:", width % this.layout.pageWidth, minTextSize);
				width = Math.ceil(width / this.layout.pageWidth) * this.layout.pageWidth;
			}

			if (this.settings.forceEvenPages) {
				columns = (width / this.layout.pageWidth);
				if ( this.layout.divisor > 1 &&
						 this.layout.name === "reflowable" &&
						(columns % 2 > 0)) {
					// add a blank page
					width += this.layout.pageWidth;
				}
			}

		} // Expand Vertically
		else if(this.settings.axis === "vertical") {
			height = this.contents.textHeight();
			minTextSize = this.rendition.themes._booksFontSize * this.rendition.themes._booksLineHeight;
			//文字高度為0時給予預設高度
			if(height === 0){
				height = this.layout.height;
			}

			if (this.settings.flow === "paginated" &&
				height % this.layout.height > minTextSize) {
				height = Math.ceil(height / this.layout.height) * this.layout.height;
			}
		}

		// Only Resize if dimensions have changed or
		// if Frame is still hidden, so needs reframing
		if(this._needsReframe || width != this._width || height != this._height){
			this.reframe(width, height);
		}

		this._expanding = false;
	}

	reframe(width, height) {
		var size;

		if(isNumber(width)){
			this.element.style.width = width + "px";
			this.iframe.style.width = width + "px";
			this._width = width;
		}

		if(isNumber(height)){
			this.element.style.height = height + "px";
			this.iframe.style.height = height + "px";
			this._height = height;
		}

		let widthDelta = this.prevBounds ? width - this.prevBounds.width : width;
		let heightDelta = this.prevBounds ? height - this.prevBounds.height : height;

		size = {
			width: width,
			height: height,
			widthDelta: widthDelta,
			heightDelta: heightDelta,
		};

		this.pane && this.pane.render();

		//加入icon
		for(let cfiRange in this.highlights){
			this.addHighlightIcon(this.highlights[cfiRange]);
		}

		requestAnimationFrame(() => {
			let mark;
			for (let m in this.marks) {
				if (this.marks.hasOwnProperty(m)) {
					mark = this.marks[m];
					this.placeMark(mark.element, mark.range);
				}
			}
		});

		this.onResize(this, size);

		this.emit(EVENTS.VIEWS.RESIZED, size);

		this.rendition.testResizeItem();

		this.prevBounds = size;

		this.elementBounds = bounds(this.element);

	}

	//加入icon
	addHighlightIcon(highlight){
		let className = $(highlight["element"]).attr("data-class");
		let classNameRule = /^highlight_.*_with_text$/;
		if(classNameRule.test(className)){
			let firstRect = $(highlight["element"]).children().first();
			let iconX = firstRect.attr("x") - 16;
			let iconY = firstRect.attr("y") - 8;
			let iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
			iconSvg.setAttribute("x", iconX);
			iconSvg.setAttribute("y", iconY);
			iconSvg.setAttribute("height", 8);
			iconSvg.setAttribute("width", 16);
			let dialogPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
			dialogPath.setAttribute("d", "M12.154 0H3.571C2.564 0 2.024.14 1.535.4A2.726 2.726 0 00.4 1.536C.139 2.024 0 2.564 0 3.57v.858c0 1.007.14 1.547.4 2.036.262.49.646.873 1.135 1.134C2.024 7.861 2.564 8 3.57 8H16V3.846c0-1.337-.14-1.822-.4-2.311A2.726 2.726 0 0014.464.4C13.976.139 13.491 0 12.155 0z");
			dialogPath.setAttribute("fill-opacity","1");
			iconSvg.appendChild(dialogPath);
			let dotPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
			dotPath.setAttribute("d", "M4 3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z");
			dotPath.setAttribute("fill-opacity","1");
			dotPath.setAttribute("fill", "#FFF");
			iconSvg.appendChild(dotPath);
			highlight["element"].appendChild(iconSvg);
		}
	}

	temporaryDestory(){

		//console.log(this.index, "temporary Destory !!!!!");

		for (let cfiRange in this.highlights) {
			this.unhighlight(cfiRange);
		}

		for (let cfiRange in this.underlines) {
			this.ununderline(cfiRange);
		}

		for (let cfiRange in this.marks) {
			this.unmark(cfiRange);
		}

		if (this.blobUrl) {
			revokeBlobUrl(this.blobUrl);
		}

		if(this.displayed){
			this.displayed = false;

			this.removeListeners();
			this.contents.destroy();

			this.stopExpanding = true;
			this.element.removeChild(this.iframe);

			if(this.emptyPage){
				this.element.removeChild(this.emptyPage);
				this.emptyPage = undefined;
			}

			if(this.loadingPage){
				this.loadingPage.style.display = "block";
				this.loadingPage.style.visibility = "visible";
			}

			if (this.pane) {
				this.pane.element.remove();
				this.pane = undefined;
			}

			this.iframe = undefined;
			this.contents = undefined;

			this._textWidth = null;
			this._textHeight = null;
			this._width = null;
			this._height = null;
		}
	}

	destroy() {

		//super.destroy();

		for (let cfiRange in this.highlights) {
			this.unhighlight(cfiRange);
		}
	
		for (let cfiRange in this.underlines) {
			this.ununderline(cfiRange);
		}
	
		for (let cfiRange in this.marks) {
			this.unmark(cfiRange);
		}
	
		if (this.blobUrl) {
			revokeBlobUrl(this.blobUrl);
		}
	
		if(this.displayed){
			this.displayed = false;
	
			this.removeListeners();
			this.contents.destroy();
	
			this.stopExpanding = true;
			this.element.removeChild(this.iframe);

			if(this.emptyPage){
				this.element.removeChild(this.emptyPage);
				this.emptyPage = undefined;
			}

			if(this.loadingPage){
				this.element.removeChild(this.loadingPage);
				this.loadingPage = undefined;
			}
	
			if (this.pane) {
				this.pane.element.remove();
				this.pane = undefined;
			}
	
			this.iframe.onload = null;
			this.iframe = undefined;
			this.contents = undefined;
	
			this._textWidth = null;
			this._textHeight = null;
			this._width = null;
			this._height = null;
	
			this.window = null;
			this.document.removeChild(this.document.documentElement);
			this.document = null;
		}
	
		
		this.book = undefined;
		this.rendition = undefined;
		this.epubcfi = undefined;
		this.highlights = undefined;
		this.underlines = undefined;
		this.marks = undefined;
	}

}

export default ExIframeView;